import { DateHelper } from "@bryntum/schedulerpro"
import { JobStatuses } from "@legacy/core/utils/enums"
import clsx from "clsx"
import { useMemo } from "react"

import { faIcon } from "@utils/faIcon"

import { Icon } from "@atoms"

import useJobTimelineViewStates from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewStates"

import styles from "./TimelineViewEventCardIcon.module.scss"
import { TimelineViewEventCardIconProps } from "./TimelineViewEventCardIcon.types"

export default function TimelineViewEventCardIcon(props: TimelineViewEventCardIconProps) {
    const { startTime, status, statusColorOverride } = props

    const { todayInUserTimezone } = useJobTimelineViewStates()

    const isPastDue = startTime !== undefined && DateHelper.isBefore(startTime, new Date(todayInUserTimezone))

    const renderIcon = useMemo(() => {
        if (JobStatuses.on_hold === status) {
            return faIcon({ name: "circle-stop", style: "solid" })
        } else if (JobStatuses.completed === status) {
            return faIcon({ name: "circle-check", style: "solid" })
        } else if (JobStatuses.finalized === status) {
            return faIcon({ name: "circle-check", style: "solid" })
        } else if (JobStatuses.cancelled === status) {
            return faIcon({ name: "circle-xmark", style: "solid" })
        } else if (JobStatuses.scheduled === status) {
            return faIcon({ name: "circle-calendar", style: "solid" })
        } else if (JobStatuses.active === status) {
            return faIcon({ name: "circle-play", style: "solid" })
        } else if (JobStatuses.paused === status) {
            return faIcon({ name: "circle-pause", style: "solid" })
        } else if (JobStatuses.pending === status && !startTime) {
            return faIcon({ name: "circle-dashed", style: "solid" })
        } else {
            return null
        }
    }, [status])

    return (
        <div
            className={clsx(styles.base, {
                [styles.pastDue]: status === JobStatuses.scheduled && isPastDue,
                [styles.scheduled]: status === JobStatuses.scheduled && !isPastDue,
                [styles.active]: status === JobStatuses.active,
                [styles.paused]: status === JobStatuses.paused,
                [styles.onHold]: status === JobStatuses.on_hold,
                [styles.onHoldInternal]: statusColorOverride === "jobs-on-hold-internal",
                [styles.onHoldExternal]: statusColorOverride === "jobs-on-hold-external",
                [styles.completed]: status === JobStatuses.completed,
                [styles.finalized]: status === JobStatuses.finalized,
                [styles.cancelled]: status === JobStatuses.cancelled,
                [styles.pending]: status === JobStatuses.pending && !startTime,
            })}
        >
            {renderIcon && <Icon icon={renderIcon} size={16} />}
        </div>
    )
}
